import * as CC from '@chakra-ui/react'
import classNames from 'classnames'
import React from 'react'
import { mapStore } from '../../state/mapStore'

interface ISearchAsMapMoves {
    tooltipLabel?: string
}

const SearchAsMapMoves: React.FC<ISearchAsMapMoves> = ({ tooltipLabel = null }) => {
    const searchAsMapMoves = mapStore((state) => state.searchAsMapMoves)
    const activeTab = mapStore((state) => state.activeTab)
    const setSearchAsMapMoves = mapStore((state) => state.setSearchAsMapMoves)
    const fallbackRadius = mapStore((state) => state.fallbackRadius)
    const setRadius = mapStore((state) => state.setRadius)

    const handleSearchAsMapMovesClick = () => {
        setSearchAsMapMoves(!searchAsMapMoves)
        if (searchAsMapMoves) {
            setRadius({
                label: fallbackRadius.label || '15 miles',
                value: fallbackRadius.value || 15,
            })
        } else {
            setRadius({ label: 'Map Bounds', value: fallbackRadius.value || 15 })
        }
    }
    const Checkbox: React.FC = () => (
        <>
            <CC.Checkbox
                isChecked={searchAsMapMoves}
                onChange={handleSearchAsMapMovesClick}
                colorScheme='gray'
                disabled={activeTab === 'routes'}
            />
            <p
                className={classNames(
                    'ml-2 text-sm font-semibold',
                    activeTab === 'routes' ? 'text-gray-200' : 'text-dark'
                )}
            >
                Search as map moves
            </p>
        </>
    )
    return activeTab === 'routes' ? (
        <CC.Tooltip placement='top' label={tooltipLabel} hasArrow>
            <div className='flex'>
                <Checkbox />
            </div>
        </CC.Tooltip>
    ) : (
        <Checkbox />
    )
}
export default SearchAsMapMoves
